import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDisplayWebContent } from '../hooks/useDisplayWebContent';
import { NameInput } from 'sections/onsite-campaigns/pages/CampaignEditor/components/NameInput';

export interface WebContentNameProps {
  id: string;
}

export const DisplayWebContentName = ({ id }: WebContentNameProps) => {
  const { t } = useTranslation('campaigns');

  const { setName, getName } = useDisplayWebContent();
  const name = getName(id);

  const onChange = useCallback(
    updatedName => {
      setName(id, updatedName);
    },
    [id, setName],
  );

  return (
    <NameInput
      title={t('onsite.editor.workflow.nameInput.messageTitle')}
      tooltip={{
        content: t('onsite.editor.workflow.nameInput.messageTooltip'),
      }}
      name={name}
      onChange={onChange}
      aria-label={t('onsite.editor.workflow.displayWebContentMessage.drawer.nameArialable')}
    />
  );
};
